/* Kavahana gift guard v4: gifts are rationed to the subscribed kits in the cart.
   v4: /cart/change.js param must be `id` (line key), not `key` — v3 400'd on every trim.
   Allowances per subscribed Starter Kit unit:
     - KH-GIFT-CUP:      2 x (total kit qty)
     - KH-GIFT-WHISK:    1 x (total kit qty)
     - KH-GIFT-5BALSTIX: 1 x (total kit qty)  (10/2: was 45-serving kit only)
   No subscribed kit => no gifts (v2 behavior kept).
   Excess quantities are trimmed line-by-line via /cart/change.
   - Reacts instantly to any cart mutation (fetch hook) + 2s polling backstop.
   - After trimming, refreshes the cart UI so shoppers never see phantom lines.
   - Hides the cart's selling-plan opt-out dropdown. 
   9/17: sweeps publish window.__kvCartSnap; first-box code route module appended (tools/kv-code-route-0917.js). */
(function () {
  if (window.__kvGiftGuard) return;
  window.__kvGiftGuard = 4;
  try {
    var st = document.createElement('style');
    st.textContent = 'select.cart-item-selling-plan-selector{display:none!important}';
    (document.head || document.documentElement).appendChild(st);
  } catch (e) {}
  var busy = false, removedSomething = false;
  function refreshUI() {
    if (!removedSomething) return;
    removedSomething = false;
    var onCartPage = location.pathname.indexOf('/cart') === 0;
    var drawer = document.querySelector('.rebuy-cart-items');
    if (onCartPage || (drawer && drawer.offsetParent)) location.reload();
  }
  function allowanceFor(sku, kitTotal, kit45) {
    if (sku.indexOf('KH-GIFT-CUP') === 0) return 2 * kitTotal;
    if (sku.indexOf('KH-GIFT-WHISK') === 0) return 1 * kitTotal;
    if (sku.indexOf('KH-GIFT-5BALSTIX') === 0) return 1 * kitTotal; /* 10/2 Bryce: 22 kit gets 5 free sticks too (was 45-only) */
    if (sku.indexOf('KH-GIFT-5RELSTIX') === 0) return 1 * kitTotal; /* 10/15 Bryce: Balance out, kit sticks are Relax */
    return 0; /* unknown KH-GIFT-* sku: not allowed */
  }
  function sweep() {
    if (busy) return; busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      window.__kvCartSnap = c;
      var items = (c && c.items) || [];
      var kitTotal = 0, kit45 = 0;
      items.forEach(function (i) {
        var s = i.sku || '';
        if (s.indexOf('KH-STARTER-KIT') === 0 && i.selling_plan_allocation) {
          kitTotal += i.quantity;
          if (s.indexOf('45') > -1) kit45 += i.quantity;
        }
      });
      /* walk gift lines in order, allocating remaining allowance per sku family */
      var used = {};
      var fix = null;
      for (var k = 0; k < items.length; k++) {
        var it = items[k], s = it.sku || '';
        if (s.indexOf('KH-GIFT-') !== 0) continue;
        var fam = s.indexOf('KH-GIFT-CUP') === 0 ? 'CUP' : (s.indexOf('KH-GIFT-WHISK') === 0 ? 'WHISK' : (s.indexOf('KH-GIFT-5BALSTIX') === 0 ? 'STIX' : s));
        var allow = allowanceFor(s, kitTotal, kit45);
        var already = used[fam] || 0;
        var permitted = Math.max(0, Math.min(it.quantity, allow - already));
        used[fam] = already + permitted;
        if (permitted < it.quantity) { fix = { id: it.key, quantity: permitted }; break; }
      }
      if (!fix) { busy = false; refreshUI(); return; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fix)
      }).then(function () { removedSomething = true; busy = false; sweep(); })
        .catch(function () { busy = false; });
    }).catch(function () { busy = false; });
  }
  try {
    var of = window.fetch;
    window.fetch = function (u) {
      var p = of.apply(this, arguments);
      try {
        var url = (typeof u === 'string') ? u : ((u && u.url) || '');
        if (/\/cart\/(change|update|add|clear)/.test(url) && !/kv_guard/.test(url)) {
          p.then(function () { setTimeout(sweep, 150); });
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}
  setInterval(sweep, 2000);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep);
  else sweep();
})();
/* Kavahana first-box code route (added 9/17/2026, lives inside both gift guards so it runs on EVERY page).
   DRINKKAVA is a once-per-customer code ($30 off the 45-serving Starter Kit, first payment only). Shopify has
   no once-per-customer switch for automatic discounts, so the code stays, and this module makes it ride along
   on every checkout exit instead of only the lander's slide cart:
     - any <a href="/checkout">, any name="checkout" button/submit, any form posting to /checkout, and any
       button whose class or label says checkout (theme cart page, theme cart drawer, replicas, portal pages)
       goes to /discount/DRINKKAVA?redirect=/checkout whenever the cart holds the 45 kit on its subscription plan;
       everything else keeps its normal target (22 kit, add-ons only, empty cart).
     - our own slide cart (#kv-cart) is left alone: it already routes itself.
     - the theme's own kit product page (no gifts, $109.99, wallet buttons the code cannot ride) redirects
       to the lander.
   Cart knowledge: window.__kvCartSnap (set by the gift guard sweeps, refreshed within ~150 ms of any cart
   mutation). No snapshot yet (click in the first second) = one no-store read of /cart.js, 1.5 s cap. */
(function () {
  if (window.__kvCodeRoute) return;
  window.__kvCodeRoute = 1;
  var CODE = 'DRINKKAVA', KIT45 = '54144064749886';
  var TARGET = '/discount/' + CODE + '?redirect=/checkout';
  var THEME_KIT_PAGE = '/products/kava-nectar-starter-kit-bundle', LANDER = '/pages/nectar-starter-kit';
  try {
    if (location.pathname.replace(/\/+$/, '') === THEME_KIT_PAGE) { location.replace(LANDER + location.search + location.hash); return; }
  } catch (e) {}
  var CHECKOUT_URL = /^(https?:\/\/[^/]+)?\/checkout\/?(\?|#|$)/;
  function has45(c) {
    var items = (c && c.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id) === KIT45 && it.selling_plan_allocation) return true;
    }
    return false;
  }
  function isCheckoutExit(el) {
    if (!el || !el.closest || el.closest('#kv-cart')) return false;
    var a = el.closest('a[href]');
    if (a && CHECKOUT_URL.test(a.getAttribute('href') || '')) return true;
    var b = el.closest('button,input[type="submit"]');
    if (b) {
      if ((b.getAttribute('name') || '') === 'checkout') return true;
      var f = b.form || b.closest('form');
      if (f && CHECKOUT_URL.test(f.getAttribute('action') || '')) return true;
      var cls = String(b.className || ''), txt = (b.textContent || b.value || '').replace(/\s+/g, ' ').trim();
      if (/checkout/i.test(cls) || /^(secure |proceed to |go to )?check ?out( now| securely)?$/i.test(txt)) return true;
    }
    return false;
  }
  var going = false;
  function leave(e, url) {
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    if (going) return;
    going = true;
    location.href = url;
  }
  function decide(e) {
    var c = window.__kvCartSnap;
    if (c) { if (has45(c)) leave(e, TARGET); return; }
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation(); else e.stopPropagation();
    if (going) return;
    going = true;
    var done = false;
    var fallback = setTimeout(function () { if (!done) { done = true; location.href = '/checkout'; } }, 1500);
    fetch('/cart.js?kv_guard=1', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (done) return; done = true; clearTimeout(fallback);
        window.__kvCartSnap = cart;
        location.href = has45(cart) ? TARGET : '/checkout';
      })
      .catch(function () { if (!done) { done = true; clearTimeout(fallback); location.href = '/checkout'; } });
  }
  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (t && t.nodeType !== 1) t = t.parentElement;
      if (t && isCheckoutExit(t)) decide(e);
    } catch (err) {}
  }, true);
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.closest || f.closest('#kv-cart')) return;
      var s = e.submitter, act = f.getAttribute('action') || '';
      if (CHECKOUT_URL.test(act) || (s && (s.getAttribute('name') || '') === 'checkout')) decide(e);
    } catch (err) {}
  }, true);
})();
